import { render, staticRenderFns } from "./confirmReceipt.vue?vue&type=template&id=d84c35fe&scoped=true"
import script from "./confirmReceipt.vue?vue&type=script&lang=js"
export * from "./confirmReceipt.vue?vue&type=script&lang=js"
import style0 from "./confirmReceipt.vue?vue&type=style&index=0&id=d84c35fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84c35fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d84c35fe')) {
      api.createRecord('d84c35fe', component.options)
    } else {
      api.reload('d84c35fe', component.options)
    }
    module.hot.accept("./confirmReceipt.vue?vue&type=template&id=d84c35fe&scoped=true", function () {
      api.rerender('d84c35fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/confirmReceipt/confirmReceipt.vue"
export default component.exports